interface ParsedField {
  value: any
  default: any
  fieldNotation: string
  label: string
  read_only: boolean
  required: boolean
  type: string
}

export default class OptionFieldsParser {
  options: object = {}
  instance: object | undefined

  constructor(optionData: object, instance = undefined) {
    this.options = optionData
    this.instance = instance
  }

  public getFieldValue(fieldNotation: string, instance: object | undefined = undefined) {
    const _instance = instance || this.instance
    if (!_instance) return
    const chunks = fieldNotation.split('__')
    return this.getValue(chunks, _instance)
  }

  public getField(fieldNotation: string): ParsedField {
    const chunks = fieldNotation.split('__')
    const field = this.getFieldObject(chunks, this.options)

    let value
    if (this.instance) {
      value = this.getValue(chunks, this.instance)
    }

    return {
      value,
      fieldNotation,
      ...field,
    }
  }

  getFields(fieldNames: Array<string>): Array<ParsedField> {
    const fields: Array<ParsedField> = []
    fieldNames.forEach(fieldName => {
      fields.push(this.getField(fieldName))
    })
    return fields
  }

  private getFieldObject(fieldNamesOriginal: Array<string>, options: object) {
    const fieldNames = [...fieldNamesOriginal]

    let fieldName = fieldNames.splice(0, 1)[0]
    if (fieldName.endsWith('_display')) {
      fieldName = fieldName.replace('_display', '')
    }
    const val = options?.[fieldName]
    if (val && val.type === 'nested object') {
      return this.getFieldObject(fieldNames, val['children'])
    } else {
      return val
    }
  }

  private getValue(fieldNamesOriginal: Array<string>, instance: object) {
    const fieldNames = [...fieldNamesOriginal]
    const fieldName = fieldNames.splice(0, 1)[0]
    const val = instance[fieldName]
    if (!val || typeof val !== 'object') {
      return val
    }
    return this.getValue(fieldNames, val)
  }
}
